import React from 'react';
import { FeatureCardsSection, FeatureCard } from 'shared-types';

interface FeatureCardsEditorProps {
    section: FeatureCardsSection;
    onChange: (newSection: FeatureCardsSection) => void;
}

const FeatureCardsEditor: React.FC<FeatureCardsEditorProps> = ({ section, onChange }) => {

    const handleTitleChange = (newTitle: string) => {
        onChange({ ...section, content: { ...section.content, title: newTitle } });
    };

    const handleCardChange = (index: number, field: keyof FeatureCard, value: string) => {
        const newCards = [...section.content.cards];
        const cardToUpdate = { ...newCards[index], [field]: value };
        newCards[index] = cardToUpdate;
        onChange({ ...section, content: { ...section.content, cards: newCards } });
    };
    
    const handleAddCard = () => {
        const newCard: FeatureCard = { id: `card_${Date.now()}`, icon: 'info', title: 'New Feature', text: 'Description' };
        const newCards = [...section.content.cards, newCard];
        onChange({ ...section, content: { ...section.content, cards: newCards } });
    };

    const handleRemoveCard = (index: number) => {
        const newCards = section.content.cards.filter((_, i) => i !== index);
        onChange({ ...section, content: { ...section.content, cards: newCards } });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="text-sm font-medium text-slate-600 dark:text-slate-400">Section Title</label>
                <input type="text" value={section.content.title} onChange={e => handleTitleChange(e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
            </div>
            <div className="space-y-3">
                {section.content.cards.map((card, index) => (
                    <div key={card.id} className="p-3 bg-slate-100 dark:bg-slate-700/50 rounded-md border border-slate-200 dark:border-slate-600/50">
                        <div className="flex justify-end mb-2">
                             <button onClick={() => handleRemoveCard(index)} className="px-2 py-1 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 text-xs font-semibold rounded-md hover:bg-red-200 dark:hover:bg-red-900/60 transition">Remove Card</button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div><label className="text-xs font-medium text-slate-500">Title</label><input type="text" value={card.title} onChange={e => handleCardChange(index, 'title', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" /></div>
                            <div><label className="text-xs font-medium text-slate-500">Icon</label><input type="text" value={card.icon} onChange={e => handleCardChange(index, 'icon', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" /></div>
                        </div>
                        <div className="mt-2"><label className="text-xs font-medium text-slate-500">Text</label><textarea value={card.text} onChange={e => handleCardChange(index, 'text', e.target.value)} rows={2} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1 resize-none" /></div>
                    </div>
                ))}
            </div>
             <button onClick={handleAddCard} className="px-3 py-1.5 bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300 text-xs font-semibold rounded-full hover:bg-cyan-200 dark:hover:bg-cyan-900/60 transition">+ Add Card</button>
        </div>
    );
};

export default FeatureCardsEditor;